// Copyright (c) Microsoft Corporation and others. Licensed under the MIT license.
// SPDX-License-Identifier: MIT

export const ROUTE_ABOUT = '/about'
export const ROUTE_WORKSPACE = '/workspace'
export const ROUTE_DEFINITIONS = '/definitions'
export const ROUTE_SHARE = '/share'
export const ROUTE_HARVEST = '/harvest'
export const ROUTE_CURATIONS = '/curations'
export const ROUTE_DISCORD = '/discord'
export const ROUTE_STATS = '/stats'
export const ROUTE_STATUS = '/status'
export const ROUTE_GETINVOLED = '/get-involved'
export const ROUTE_CHARTER = '/charter'
export const ROUTE_FILE = '/file'
export const ROUTE_ROOT = '/'
